import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import { useState } from "react";
import { changeAppState } from "../../../../../common/appState";
import ShurikenProgress from "../../../../shared/Animations/ShurikenProgress";
import { PrimaryButton } from "../../../../shared/Button/PrimaryButton";
import { RightPanel } from "../../../../shared/Panel/RightPanel";
import { User } from "../../../../shared/User/types";

export function PersonalBankruptcyButton({
    user,
    scrollingDown,
}: {
    user: User;
    scrollingDown: boolean;
}) {
    const [isPanelOpen, setPanelOpen] = useState(false);
    return (
        <>
            <Button
                color="secondary"
                variant="outlined"
                style={{
                    position: "absolute",
                    top: scrollingDown ? -37 : -71,
                    left: 1,
                    height: 35,
                    backgroundColor: "white",
                }}
                startIcon={<AccountBalanceIcon />}
                onClick={() => {
                    setPanelOpen(true);
                }}
            >
                Personal Bankruptcy
            </Button>

            <PersonalBankruptcyPanel
                open={isPanelOpen}
                setPanelOpen={setPanelOpen}
                user={user}
            />
        </>
    );
}

function PersonalBankruptcyPanel({
    open,
    setPanelOpen,
    user,
}: {
    open: boolean;
    setPanelOpen: (open: boolean) => void;
    user: User;
}) {
    return (
        <RightPanel
            panelName="PersonalBankruptcyPanel"
            open={open}
            onClose={() => {
                setPanelOpen(false);
            }}
            panelWidth={500}
        >
            {open && (
                <Content
                    user={user}
                    closePanel={() => {
                        setPanelOpen(false);
                    }}
                />
            )}
        </RightPanel>
    );
}

function Content({ user, closePanel }: { user: User; closePanel: () => void }) {
    const c = usePanelContentStyle();
    const [submitting, setSubmitting] = useState(false);
    return (
        <div className={c.container}>
            <h2 className={c.title}>Personal Bankruptcy</h2>

            <div className={c.text}>
                Currently, your coins are negative. By filing for bankruptcy,
                you can reset your coin value to 0. In exchange, you will
                receive less experience points for leveling up in the future.
                Filing for bankruptcy multiple times may result in other
                penalties being applied.
                <br />
                <br />
                You can also reset your coins to a positive value yourself by:
                <ul>
                    <li>Completing quests</li>
                    <li>Gifts from friends</li>
                </ul>
                <br />
                Do you want to file for bankruptcy?
            </div>

            <PrimaryButton
                startIcon={<AccountBalanceIcon />}
                style={{ marginTop: 30 }}
                onClick={async () => {
                    setSubmitting(true);
                    await fetchPersonalBankruptcy(user.userId);
                    setSubmitting(false);
                    closePanel();
                }}
                disabled={submitting}
            >
                {submitting ? <ShurikenProgress size={15} /> : "Bankrupt Now"}
            </PrimaryButton>
        </div>
    );
}
const usePanelContentStyle = makeStyles({
    container: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        paddingRight: 35,
        paddingLeft: 5,
        paddingBottom: 40,
        margin: "0 15px",
    },
    title: {
        padding: "0 20px",
        marginBottom: 20,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "100%",
        height: 48,
        fontWeight: "bold",
        textAlign: "center",
    },
    text: {
        fontSize: "large",
    },
});

async function fetchPersonalBankruptcy(userId: number): Promise<void> {
    const formData = new FormData();
    formData.append("userId", userId.toString());

    const res = await fetch("api/User/PersonalBankruptcy", {
        method: "POST",
        body: formData,
    });
    const result = await res.json();
    if (result) {
        changeAppState("user", result);
    }
}
